<template>
  <v-container>
    <h2>Check on import into revenue item</h2>
    <h5>This check is to verify that S3 files were imported into ARC DB</h5>
	<v-progress-circular
			indeterminate
			color="primary"
			v-show="isLoading"
	></v-progress-circular>
      <v-data-table
        :items="healthData"
        :items-per-page="10"
        :headers="headers"
        no-data-text="There is no data."
		:sort-by.sync="columnNameToSortBy"
		:sort-desc.sync="isDescending"
        fix-header
      >
      </v-data-table>
      <template v-slot:item.order_date="{ item }">
        {{ item.order_date | toDate }}
      </template>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
	name: 'AdminImport',
	props: ['selectedMandators'],
	data() {
		return {
			healthData: [],
			isLoading: false,
			columnNameToSortBy: 'order_date',
			isDescending: true,
			selected: [],
			headers: [{
				text: 'Mandator',
				value: 'mandator_name',
			}, {
				text: 'Order Date',
				value: 'order_date',
			}, {
				text: 'Imported At',
				value: 'imported_at',
			}, {
				text: 'Installation ID',
				value: 'installation_id',
			}],
		}
	},
	methods: {
	},
	watch: {
		selectedMandators: {
			async handler() {
				try {
					this.isLoading = true
					const r = await axios.get(
						`${config.baseAPIurl}/admin-page/health-revenue?installationId=${this.selectedMandators.value}`
					)
					this.healthData = r.data
				} catch (e) {
					console.log('Error', e)
				} finally {
					this.isLoading = false
				}
			},
		},
	},
	filters: {
		toDate(value) {
			date = new Date(value)
			return date.toUTCString()
		},
	},
};
</script>

<style scoped>
.seachFiledImportReveneue {
  width: 50%;
  padding-left: 20px;
}

.checkImportHealth {
  padding-top: 25px;
  background-color: rgba(37, 160, 168, 0.2);
}
</style>
